var Backbone, SupportUserSignInTemplate, SupportUserSignInView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportUserSignInTemplate = require('../../user_sign_in.html.mustache');

SupportUserSignInView = (function(superClass) {
  extend(SupportUserSignInView, superClass);

  function SupportUserSignInView() {
    return SupportUserSignInView.__super__.constructor.apply(this, arguments);
  }

  SupportUserSignInView.prototype.initialize = function(options) {
    this.options = options || {};
    return this.template = SupportUserSignInTemplate;
  };

  SupportUserSignInView.prototype.events = {
    'click #my-account-sign-in': 'redirectToLoginFromMyAccount',
    'click #my-order-sign-in-id': 'redirectToLoginFromMyOrder'
  };

  SupportUserSignInView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.options, this.I18nScope));
  };

  SupportUserSignInView.prototype.redirectToLoginFromMyAccount = function() {
    var refUrl;
    refUrl = window.SUPPORTBASEURL + "?flow=my_account";
    return window.location.href = "/login?ref=" + (encodeURIComponent(refUrl));
  };

  SupportUserSignInView.prototype.redirectToLoginFromMyOrder = function() {
    var refUrl;
    refUrl = window.SUPPORTBASEURL + "?flow=my_order";
    return window.location.href = "/login?ref=" + (encodeURIComponent(refUrl));
  };

  return SupportUserSignInView;

})(Backbone.View);

module.exports = SupportUserSignInView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvdXNlcl9zaWduX2luX3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvdXNlcl9zaWduX2luX3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsMERBQUE7RUFBQTs7O0FBQUEsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBQ2IseUJBQUEsR0FBNEIsT0FBQSxDQUFRLGtDQUFSOztBQUV0Qjs7Ozs7OztrQ0FDSixVQUFBLEdBQVksU0FBQyxPQUFEO0lBQ1YsSUFBQyxDQUFBLE9BQUQsR0FBVyxPQUFBLElBQVc7V0FDdEIsSUFBQyxDQUFBLFFBQUQsR0FBWTtFQUZGOztrQ0FJWixNQUFBLEdBQ0U7SUFBQSwyQkFBQSxFQUE2Qiw4QkFBN0I7SUFDQSw0QkFBQSxFQUErQiw0QkFEL0I7OztrQ0FHRixNQUFBLEdBQVEsU0FBQTtXQUNOLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLE1BQUEsQ0FBTyxJQUFDLENBQUEsUUFBUixFQUFrQixJQUFDLENBQUEsT0FBbkIsRUFBNkIsSUFBQyxDQUFBLFNBQTlCLENBQVY7RUFETTs7a0NBR1IsNEJBQUEsR0FBOEIsU0FBQTtBQUM1QixRQUFBO0lBQUEsTUFBQSxHQUFZLE1BQU0sQ0FBQyxjQUFSLEdBQXVCO1dBQ2xDLE1BQU0sQ0FBQyxRQUFRLENBQUMsSUFBaEIsR0FBdUIsYUFBQSxHQUFhLENBQUMsa0JBQUEsQ0FBbUIsTUFBbkIsQ0FBRDtFQUZSOztrQ0FJOUIsMEJBQUEsR0FBNEIsU0FBQTtBQUMxQixRQUFBO0lBQUEsTUFBQSxHQUFZLE1BQU0sQ0FBQyxjQUFSLEdBQXVCO1dBQ2xDLE1BQU0sQ0FBQyxRQUFRLENBQUMsSUFBaEIsR0FBdUIsYUFBQSxHQUFhLENBQUMsa0JBQUEsQ0FBbUIsTUFBbkIsQ0FBRDtFQUZWOzs7O0dBaEJNLFFBQVEsQ0FBQzs7QUFvQjdDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
